class ObraSocial {
    constructor(id, codigo, descripcion, codigo_afip) {
        this.id = id;
        this.codigo = codigo;
        this.codigo_afip = codigo_afip;
        this.descripcion = descripcion;
    }
}
export default ObraSocial;